<template>
  <div class="block">
    <ValidationObserver ref="observer" v-slot="{ handleSubmit, invalid }">
      <div class="box" :style="{ 'min-height': minHeight }">
        <div class="columns is-multiline">
          <div class="column is-half">
            <b-field>
              <BSelectWithValidation
                label="Lizenz Typ"
                v-model="data.license_type"
                expanded
              >
                <option value="main">Hauptlizenz</option>
                <option value="sub">Unterlizenz</option>
              </BSelectWithValidation>
            </b-field>
            <b-field>
              <b-checkbox v-model="data.test">
                Lizenz ist Test Version
              </b-checkbox>
            </b-field>
          </div>
          <div v-if="data.license_type === 'sub'" class="column is-half">
            <BSelectWithValidation
              label="Zugehörig zu"
              v-model="data.main_license_org_id"
              expanded
            >
              <template v-for="org in orgsWithMainLicence">
                <option :key="org.id" :value="org.id">{{ org.name }}</option>
              </template>
            </BSelectWithValidation>
          </div>
          <div class="column is-half">
            <BInputWithValidation
              type="text"
              label="Lizenz-Nr."
              v-model="data.license_no"
            />
          </div>
        </div>
        <div class="columns">
          <div v-if="data.expires_at !== null" class="column is-half">
            <b-field label="Laufzeit">
              <b-datepicker
                v-model="expiresAt"
                :min-date="new Date()"
                placeholder="Click to select..."
                icon="calendar-day"
                trap-focus
              >
              </b-datepicker>
            </b-field>
            <b-field v-if="!data.test">
              <b-checkbox v-model="data.contract_renews">
                Vertrag verlängert sich
              </b-checkbox>
            </b-field>
          </div>
          <div class="column is-half">
            <b-field>
              <BSelectWithValidation
                label="Zugehörig zu"
                v-model="data.tableau_user_id"
                expanded
              >
                <template v-for="tableauUser in tableauUsers">
                  <option :key="tableauUser.id" :value="tableauUser.id">
                    {{ tableauUser.name }}
                  </option>
                </template>
              </BSelectWithValidation>
            </b-field>
          </div>
        </div>
        <slot name="subscription"></slot>
      </div>
      <div class="is-flex is-justify-content-end">
        <b-button
          type="is-gold"
          :disabled="invalid"
          @click="handleSubmit(submit)"
        >
          Speichern
        </b-button>
      </div>
      <!-- <div class="block" v-if="error">
        <b-message type="is-danger">
          {{ error }}
        </b-message>
      </div> -->
    </ValidationObserver>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import helper from '@/functions/helper';
import BInputWithValidation from '@/components/inputs/BInputWithValidation.vue';
import BSelectWithValidation from '@/components/inputs/BSelectWithValidation.vue';

export default {
  name: 'OrgLicense',
  components: {
    BInputWithValidation,
    BSelectWithValidation,
  },
  data() {
    return {
      // expires_at: new Date(this.data.expires_at),
    };
  },
  props: {
    data: {
      required: true,
    },
    height: {
      type: String,
      required: false,
      default: 'auto',
    },
    minHeight: {
      type: String,
      required: false,
      default: 'initial',
    },
  },
  computed: {
    orgsWithMainLicence() {
      return this.orgs.filter((item) => item.license_type === 'main' && item.id !== this.data.id);
    },
    ...mapGetters({
      orgs: 'org/data',
      tableauUsers: 'tableau/data',
    }),
    expiresAt: {
      get() {
        return new Date(this.data.expires_at);
      },
      set(val) {
        this.data.expires_at = helper.dateToTime(val);
      },
    },
  },
  methods: {
    submit() {
      if (this.data.license_no === '' || this.data.license_no === null) {
        this.data.license_no = null;
      } else {
        this.data.license_no = Number(this.data.license_no);
      }

      // if (this.data.expires_at === null) this.expires_at = this.data.expires_at;

      if (this.data.test) {
        this.data.contract_renews = false;
      }

      if (this.data.license_type === 'main') {
        this.$emit('submit', {
          id: this.data.id,
          license_type: this.data.license_type,
          license_no: this.data.license_no,
          contract_renews: this.data.contract_renews,
          test: this.data.test,
          expires_at: this.data.expires_at,
          tableau_user_id: this.data.tableau_user_id,
        });
      } else {
        this.$emit('submit', {
          id: this.data.id,
          license_type: this.data.license_type,
          license_no: this.data.license_no,
          main_license_org_id: this.data.main_license_org_id,
          contract_renews: this.data.contract_renews,
          test: this.data.test,
          expires_at: this.data.expires_at,
          tableau_user_id: this.data.tableau_user_id,
        });
      }
    },
  },
  watch: {},
};
</script>
